import { createSelector } from 'reselect'
import { getVillaViews } from '../view/villa'
import getBedbankItemViews from '../view/itemViews/getBedbankItemViews'
import getHotelItemViews from '../view/itemViews/getHotelItemViews'
import getTourV2ItemViews from '../view/itemViews/getTourV2ItemViews'

/**
 * Sums the price of all international accommodation items in the checkout cart.
 * Used to determine Taste of Gold eligibility when the per-offer minimum isn't met
 * but the combined international total is.
 */
const getCheckoutInternationalItemsTotal = createSelector(
  (state: App.State) => getBedbankItemViews(state),
  (state: App.State) => getHotelItemViews(state),
  (state: App.State) => getTourV2ItemViews(state),
  (state: App.State) => getVillaViews(state),
  (state: App.State) => state.geo.currentRegionCode.toLowerCase(),
  (bedbankViews, hotelViews, tourV2Views, villaViews, regionCode): number => {
    let total = 0

    for (const view of bedbankViews.data) {
      if (view.offer && view.offer.property.address.countryCode.toLowerCase() !== regionCode) {
        total += view.itemViews.reduce((sum, iv) => sum + iv.totals.price, 0)
      }
    }

    for (const view of hotelViews.data) {
      if (view.offer && view.offer.property!.geoData.countryCode?.toLowerCase() !== regionCode) {
        total += view.itemViews.reduce((sum, iv) => sum + iv.totals.price, 0)
      }
    }

    for (const view of tourV2Views.data) {
      const hasInternationalDeparture = view.itemViews.some(iv => {
        const departureId = iv.item.purchasableOption.fkVariationId
        return view.offer?.variations[departureId]?.countriesVisited.some(
          country => country.toLowerCase() !== regionCode,
        )
      })
      if (hasInternationalDeparture) {
        total += view.itemViews.reduce((sum, iv) => sum + iv.totals.price, 0)
      }
    }

    for (const view of villaViews.data) {
      if (view.offer.property.geoData.countryCode?.toLowerCase() !== regionCode) {
        total += view.totals.price
      }
    }

    return total
  },
)

export default getCheckoutInternationalItemsTotal
